import { CheckedCourses } from "../store/autodelivery/store";
import http from "./client";


async function getSingupCourses() {
  const response = await http.get('/api/host/signup-courses');

  return response.data.data;
}

async function saveSignupCourses(checked: Record<number, CheckedCourses>) {
  await http.post('/api/host/signup-courses', {settings: checked});
}
const host = {
  getSingupCourses, saveSignupCourses
}
export default host;